import { render, staticRenderFns } from "./FuncionarioEditar.vue?vue&type=template&id=3d32dc92"
import script from "./FuncionarioEditar.vue?vue&type=script&lang=js"
export * from "./FuncionarioEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports